/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.RawDataMappingColumn = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The RawDataMappingColumn model module.
   * @module model/RawDataMappingColumn
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>RawDataMappingColumn</code>.
   * @alias module:model/RawDataMappingColumn
   * @class
   */
  var exports = function() {
    var _this = this;










  };

  /**
   * Constructs a <code>RawDataMappingColumn</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/RawDataMappingColumn} obj Optional instance to populate.
   * @return {module:model/RawDataMappingColumn} The populated <code>RawDataMappingColumn</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('MappingID')) {
        obj['MappingID'] = ApiClient.convertToType(data['MappingID'], 'Integer');
      }
      if (data.hasOwnProperty('ColumnID')) {
        obj['ColumnID'] = ApiClient.convertToType(data['ColumnID'], 'Integer');
      }
      if (data.hasOwnProperty('DataTypeID')) {
        obj['DataTypeID'] = ApiClient.convertToType(data['DataTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('TrackingLevelID')) {
        obj['TrackingLevelID'] = ApiClient.convertToType(data['TrackingLevelID'], 'Integer');
      }
      if (data.hasOwnProperty('DimensionID')) {
        obj['DimensionID'] = ApiClient.convertToType(data['DimensionID'], 'Integer');
      }
      if (data.hasOwnProperty('PeriodTypeID')) {
        obj['PeriodTypeID'] = ApiClient.convertToType(data['PeriodTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('IndicatorID')) {
        obj['IndicatorID'] = ApiClient.convertToType(data['IndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('AddUnmatchedItems')) {
        obj['AddUnmatchedItems'] = ApiClient.convertToType(data['AddUnmatchedItems'], 'Boolean');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} MappingID
   * @default 0
   */
  exports.prototype['MappingID'] = 0;
  /**
   * @member {Integer} ColumnID
   * @default 0
   */
  exports.prototype['ColumnID'] = 0;
  /**
   * @member {Integer} DataTypeID
   */
  exports.prototype['DataTypeID'] = undefined;
  /**
   * @member {Integer} TrackingLevelID
   */
  exports.prototype['TrackingLevelID'] = undefined;
  /**
   * @member {Integer} DimensionID
   */
  exports.prototype['DimensionID'] = undefined;
  /**
   * @member {Integer} PeriodTypeID
   */
  exports.prototype['PeriodTypeID'] = undefined;
  /**
   * @member {Integer} IndicatorID
   */
  exports.prototype['IndicatorID'] = undefined;
  /**
   * @member {Boolean} AddUnmatchedItems
   * @default false
   */
  exports.prototype['AddUnmatchedItems'] = false;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


